import axios from 'axios';
import router from '@/router';
import store from '@/store';
import VueSimpleAlert from "vue-simple-alert";

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
            .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
            .join('&');

const api = {
    url: 'https://api.briskly.online/terminal-api/v1',
    token: null,
    async auth(user) {
        axios.defaults.withCredentials = true;
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        const utm = localStorage.getItem('utm');
        let data = transformRequest(user);
        if (this.utm) {
            data += `&${transformRequest(JSON.parse(this.utm))}`;
        }
        data += `&uid=${localStorage.getItem('uid')}`;
        const res = axios.post(`${this.url}/user/login`, data, config)
                .then((response) => {
                    if (response.data.error) {
                        return response;
                    }
                    localStorage.setItem('access_token', response.data.tokens.access_token);
                    localStorage.setItem('refresh_token', response.data.tokens.refresh_token);
                    store.state.isAuthorized = true;
                    this.get('/user-dashboard/').then((response) => {
                        store.commit('init', response.data);
                        if (localStorage.getItem('redirect_url')) {
                            const redirectLink = `${localStorage.getItem('redirect_url')}`;
                            localStorage.removeItem('redirect_url');
                            document.location = redirectLink;
                        } else {
                            router.push('/feed');
                        }
                    });
                })
                .catch((error) => {
                    // console.log(error);
                    // handle error
                    // console.log(error);
                })
                .finally(() => {
                    // always executed
                });

        return res;
    },
    async register(user) {
        axios.defaults.withCredentials = true;
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };

        const utm = localStorage.getItem('utm');
        let data = transformRequest(user);
        if (utm) {
            data += `&${transformRequest(JSON.parse(utm))}`;
        }
        data += `&uid=${localStorage.getItem('uid')}`;
        const res = axios.post(`${this.url}/user/register`, data, config)
                .then((response) => {
                    if (response.data.error) {
                        return response;
                    }
                    localStorage.setItem('access_token', response.data.tokens.access_token);
                    localStorage.setItem('refresh_token', response.data.tokens.refresh_token);
                    store.state.isAuthorized = true;
                    this.get('/user-dashboard/').then((response) => {
                        store.commit('init', response.data);
                        if (localStorage.getItem('redirect_url')) {
                            const redirectLink = `${localStorage.getItem('redirect_url')}?tutorial=1`;
                            localStorage.removeItem('redirect_url');
                            document.location = redirectLink;
                        } else {
                            router.push('/feed');
                        }
                    });
                })
                .catch((error) => {
                    // console.log(error);
                    // handle error
                    // console.log(error);
                })
                .finally(() => {
                    // always executed
                });

        return res;
    },
    async recoveryPassword(email) {
        axios.defaults.withCredentials = true;
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        const res = axios.post(`${this.url}/user/recovery`, {
            email,
        }, config)
                .then(response => response)
                .catch((error) => {

                })
                .finally(() => {

                });

        return res;
    },

    checkVersion(version) {
        if (localStorage.getItem('version') !== version) {
            localStorage.setItem('version', version);
            document.location.reload(true);
        }
    },

    async get(url, data) {
//    if (this.token === null) {
//      this.token = localStorage.getItem('access_token');
//      if (this.token) {
//        axios.defaults.headers.common.Authorization = `Bearer ${this.token}`;
//      }
//    }

        let requestData = `?${transformRequest(data)}`;
        if (this.utm) {
            requestData += `&${transformRequest(JSON.parse(this.utm))}`;
        }
        //requestData += `&uid=${localStorage.getItem('uid')}`;
        const request = requestData;
        const res = axios.get(this.url + url + request)
                .then((response) => {
                    if (response.data.error && response.data.error.type && response.data.error.type === 'auth') {
                        if (response.data.error.message === 'access_token_expired') {
                            this.token = localStorage.getItem('refresh_token');
                            axios.defaults.headers.common.Authorization = `Bearer ${this.token}`;
                            return axios.get(this.url + url).then((refreshResponse) => {
                                if (refreshResponse.data.error && refreshResponse.data.error.message === 'refresh_token_expired') {
                                    router.push('/logout');
                                } else {
                                    localStorage.setItem('access_token', refreshResponse.data.error.tokens.access_token);
                                    localStorage.setItem('refresh_token', refreshResponse.data.error.tokens.refresh_token);
                                    this.token = localStorage.getItem('access_token');
                                    axios.defaults.headers.common.Authorization = `Bearer ${this.token}`;
                                    return axios.get(this.url + url).then(newResponse => newResponse);
                                }
                            });
                        }
                    }
                    if (typeof response.data.version !== 'undefined' && response.data.version) {
                        this.checkVersion(response.data.version);
                    }

                    if (response.data.error && response.data.error.message === 'refresh_token_expired') {
                        router.push('/logout');
                    }

                    if (response.data.error && response.data.message === 'Not authorized') {
                        router.push('/logout');
                    }

                    return response;
                })
                .catch((error) => {
                    return error.response;
                })
                .finally(() => {
                    // always executed
                });

        return res;
    },
    async post(url, data) {
        axios.defaults.withCredentials = true;
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
//    if (this.token === null) {
//      this.token = localStorage.getItem('access_token');
//      if (this.token) {
//        axios.defaults.headers.common.Authorization = this.token;
//      }
//    }
        const res = axios.post(this.url + url, transformRequest(data), config)
                .then(response => response)
                .catch((error) => {
                    //console.log(error.response);
                    VueSimpleAlert.alert(error.response.data.error.message);
                })
                .finally(() => {
                    // always executed
                });

        return res;
    },
};
export default api;
// axios.defaults.headers.common.Authorization = resp.token;
